import { createSlice } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  BROADCAST: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "BROADCAST",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getBroadcastList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getBroadcastList.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      BROADCAST: payload,
      totalCount: payload.total_record_count || 0, // Ensure totalCount is set properly
    }));
    builder.addCase(Act.getBroadcastList.rejected, (state, action) => ({
      ...state,
      loading: false,
      BROADCAST: [],
      totalCount: 0,
    }));
    builder.addCase(Act.sendBroadcastMessage.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.sendBroadcastMessage.fulfilled, (state) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(Act.sendBroadcastMessage.rejected, (state) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(Act.getBroadcastDetail.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getBroadcastDetail.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(Act.getBroadcastDetail.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
  },
});

export default slice;
